import { observer } from "mobx-react-lite";
import React from "react";
import Modal from "react-bootstrap/Modal";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import ExemptionDetailSectionViewModel from "viewModels/callCenter/search/exemptions/detailExemption/exemptionDetailSectionViewModel";
import Tabs from "views/common/tabs";

const ExemptionDetailSectionView: ViewComponent<ExemptionDetailSectionViewModel> = observer(({ vm }) => {
  return (
    <Modal show={true} onHide={vm.onClose} dialogClassName="modal-65w modal-100h" centered scrollable>
      <Modal.Header closeButton={true}>
        <Modal.Title>{vm.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs vm={vm} />
      </Modal.Body>
    </Modal>
  );
});

registerView(ExemptionDetailSectionView, ExemptionDetailSectionViewModel);
